import { render, staticRenderFns } from "./weidian.vue?vue&type=template&id=c109206c&scoped=true"
import script from "./weidian.vue?vue&type=script&lang=ts"
export * from "./weidian.vue?vue&type=script&lang=ts"
import style0 from "./weidian.vue?vue&type=style&index=0&id=c109206c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c109206c",
  null
  
)

export default component.exports